import store, { subscribe } from 'shared/store'
import logger from 'shared/services/logger'

import { REFRESH_MODALS } from 'shared/store/ducks/events'

import attachScript from './attachScript'

const NowAPIInfoInitZipCode = ''

export const openNowModal = () => {
  const {
    pageProperties: { pzn }
  } = store.getPublicRuntimeConfig()

  // @ts-ignore
  let nowModalApi = window.NowAPIInfo

  if (typeof nowModalApi !== 'undefined') {
    nowModalApi.openInfoModal(null, pzn)
  } else {
    const { publicConfig } = store.getPublicRuntimeConfig()
    attachScript({
      src: publicConfig.nowWidget.url,
      callback: () => {
        // @ts-ignore
        nowModalApi = window.NowAPIInfo

        nowModalApi.setShop(
          publicConfig.nowWidget.shopName,
          publicConfig.nowWidget.shopEnv
        )
        nowModalApi.openInfoModal(NowAPIInfoInitZipCode, pzn)
      },
      error: error => {
        logger.error(error)
      }
    })
  }
}

const isValidEnv = () => {
  const { publicConfig } = store.getPublicRuntimeConfig()

  return (
    publicConfig.nowWidget &&
    [
      publicConfig.nowWidget.url,
      publicConfig.nowWidget.shopName,
      publicConfig.nowWidget.shopEnv
    ].every(Boolean)
  )
}

const getNowModalElements = selector => {
  const htmlElement = selector ? document.querySelector(selector) : document
  const widgets = htmlElement?.querySelectorAll(
    '[data-clientside-hook~="nowWidget"]'
  )

  return widgets?.length ? [...widgets] : []
}

const bindModals = selector => {
  if (!isValidEnv()) {
    return
  }

  getNowModalElements(selector).forEach(element => {
    element.removeEventListener('click', openNowModal)
    element.addEventListener('click', openNowModal)
  })
}

export default () => {
  bindModals()
  // @ts-ignore
  subscribe.after(REFRESH_MODALS, ({ selector }) => {
    bindModals(selector)
  })
}
